<template lang="pug">
  div(v-click-outside="hide")
    .job-show(:class="{ open: isOpened }")
      .job-show-modal#job-show-modal
        a.job-show-modal-close(@click="hide")
          | 閉じる
        .job-show-modal-header
          .new(v-if="startingBusinessDetail.is_new")
            span.label NEW
          .employment_name
            span.label {{ startingBusinessDetail.genre }}
          h4.catchcopy
            | {{ startingBusinessDetail.facility_name }}
          .company_name
            | {{ startingBusinessDetail.corporate_name }}
        .job-show-modal-body
          .row
            .col.title
              | 名前
            .col
              span {{ startingBusinessDetail.facility_name }}
          .row
            .col.title
              | 保健所名
            .col
              span {{ startingBusinessDetail.health_center_name }}
          .row
            .col.title
              | 電話番号
            .col
              span {{ startingBusinessDetail.phone_number }}
          .row
            .col.title
              | 住所
            .col
              span {{ startingBusinessDetail.address }}

          .row(v-if="startingBusinessDetail.food_industry_comment")
            .col.title
              | 業種
            .col
              span {{ startingBusinessDetail.food_industry_comment }}
          .row(v-if="startingBusinessDetail.food_business_format_comment")
            .col.title
              | 業態
            .col
              span {{ startingBusinessDetail.food_business_format_comment }}
          .row(v-if="startingBusinessDetail.food_etc")
            .col.title
              | その他
            .col
              span {{ startingBusinessDetail.food_etc }}

          .row(v-if="startingBusinessDetail.beauty_store_genre")
            .col.title
              | お店ジャンル
            .col
              span {{ startingBusinessDetail.beauty_store_genre }}
          .row(v-if="startingBusinessDetail.beauty_seat_count && startingBusinessDetail.beauty_seat_count != '0'")
            .col.title
              | セット椅子数
            .col
              span {{ startingBusinessDetail.beauty_seat_count }}
          .row(v-if="startingBusinessDetail.beauty_store_area && startingBusinessDetail.beauty_store_area != '0'")
            .col.title
              | 総床面積
            .col
              span {{ startingBusinessDetail.beauty_store_area }}
          .row(v-if="startingBusinessDetail.beauty_hairdresser_count && startingBusinessDetail.beauty_hairdresser_count != '0'")
            .col.title
              | 美容師の人数
            .col
              span {{ startingBusinessDetail.beauty_hairdresser_count }}

          .row(v-if="startingBusinessDetail.applicant_position_name")
            .col.title
              | 申請者氏名
            .col
              span {{ startingBusinessDetail.applicant_position_name }}
          .row(v-if="startingBusinessDetail.applicant_phone_number")
            .col.title
              | 申請者電話番号
            .col
              span {{ startingBusinessDetail.applicant_phone_number }}
          .row(v-if="startingBusinessDetail.applicant_address")
            .col.title
              | 申請者住所
            .col
              span {{ startingBusinessDetail.applicant_address }}
          .row(v-if="startingBusinessDetail.corporate_name")
            .col.title
              | 申請法人
            .col
              span {{ startingBusinessDetail.corporate_name }}
          .row(v-if="startingBusinessDetail.corporate_number")
            .col.title
              | 法人番号
            .col
              span {{ startingBusinessDetail.corporate_number }}
          .row
            .col.title
              | 開業年月日
            .col
              span {{ startingBusinessDetail.open_date }}
          .row
            .col.title
              | 開業基準日
            .col
              span {{ startingBusinessDetail.search_date }}
          .row
            .col.title
              | 許可年月日
            .col
              span {{ startingBusinessDetail.permission_date }}
          .row
            .col.title
              | 申請年月日
            .col
              span {{ startingBusinessDetail.applicant_date }}

          .row(v-if="startingBusinessDetail.food_valid_start_date")
            .col.title
              | 許可期間開始日
            .col
              span {{ startingBusinessDetail.food_valid_start_date }}
          .row(v-if="startingBusinessDetail.food_valid_end_date")
            .col.title
              | 許可期間終了日
            .col
              span {{ startingBusinessDetail.food_valid_end_date }}

        template(v-if="startingBusinessDetail.in_list")
          .sales-status-modal-header
            h4 営業状況
            span 最終更新: {{ startingBusinessDetail.list.updated_at }}（{{ startingBusinessDetail.list.updated_by }}）
          .sales-status-modal-body
            form(@submit.prevent="updateStartingBusinessList")
              .row
                .col.title
                  | 営業ステータス
                .col
                  select(v-model="salesStatus")
                    option(v-for="option in $store.state.master.salesStatuses" :value="option.code") {{ option.name }}
              .row
                .col.title
                  | 営業担当者
                .col
                  select(v-model="assignedTo")
                    option(v-for="option in clientUsers" :value="option.id") {{ option.name }}
              .row
                .col.title
                  | コメント
                .col
                  textarea(v-model="salesStatusComment")
                button.button-more(type="submit" value="コメントを更新する")
                  | 更新する
              ul.timeline
                li(v-for="comment in startingBusinessDetail.list.comments")
                  .timeline-date
                    | {{ comment.created_at.split(' ')[0] }}
                    p.time
                      i.far.fa-clock
                      |  {{ comment.created_at.split(' ')[1] }}
                  .timeline-comment
                    .timeline-text(v-html="autoLink(comment.comment)")
                    .timeline-author
                      i.fas.fa-user
                      |  {{ comment.author }}
    .modal-cover
</template>

<script>
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import AbbreviationText from './AbbreviationText'
  import { HumanInfoMessages } from '../../constants'
  import mapGetSet from '../../libs/map-get-set'
  import startingBusiness from '../../store/modules/startingBusiness'

  export default {
    components: { AbbreviationText },
    directives: { ClickOutside },
    props: ['startingBusiness', 'startingBusinessDetail', 'isOpened', 'updateFavorForIndex'],

    mounted () {
      this.popupItem = this.$el
    },

    computed: {
      ...mapState({
        user: state => state.user.detail,
      }),
      ...mapGetters('common', ['spMode']),
      ...mapGetters('client', ['clientUsers']),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.startingBusiness[k],
        set: ($vm, $s, k, v) => $s.commit(`startingBusiness/${k}`, v),
        keys: Object.keys(startingBusiness.state),
      }),
    },

    data () {
      return {
        needsDetail: false,
        detailIsOpened: false,
        hasAgentCompany: false,
        salesStatusComment: '',
        salesStatus: '',
        assignedTo: '',
      }
    },

    watch: {
      startingBusinessDetail () {
        this.scrollTop()
        this.detailIsOpened = false
        this.initSalesStatusForm()
      },
      isOpened () {
        this.detailIsOpened = false
        if (this.isOpened) {
          this.scrollTop()
          this.initSalesStatusForm()
        }
      },
    },

    methods: {
      ...mapMutations('startingBusiness', ['uncheckAll', 'clearDetail']),
      hide () {
        this.$emit('hide')
      },
      initSalesStatusForm () {
        if (this.startingBusinessDetail.in_list) {
          this.salesStatus = this.startingBusinessDetail.list.sales_status_id
          this.assignedTo = this.startingBusinessDetail.list.assigned_to_id
          this.salesStatusComment = ''
        }
      },
      autoLink (text) {
        return text.replace(/(https?:\/\/[\x21-\x7e]+)/gi, "<a href='$1' target='_blank'>$1</a>")
      },
      scrollTop () {
        const modal = document.getElementById('job-show-modal')
        if (modal) {
          modal.scrollTop = 0
        }
      },
      update () {
        if (!this.updateFavorForIndex) {
          this.$emit('hide')
          this.clearDetail()
        }
        this.$emit('update', { id: this.startingBusinessDetail.id })
      },
      async updateStartingBusinessList () {
        this.$store.commit('common/lockGlobal')
        const id = this.startingBusinessDetail.list.id
        const salesStatusId = this.salesStatus
        const assignedToId = this.assignedTo
        const comment = this.salesStatusComment
        try {
          this.$store.dispatch('startingBusinessList/update', { id, salesStatusId, assignedToId, comment })
          this.salesStatusComment = ''
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SAVE_SALES_STATUS })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessShowModal.vue